import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import MainContent from './components/MainContent';
import TentangKami from './components/TentangKami';
import Lokasi from './components/Lokasi';
import Kendaraan from './components/Kendaraan';
import Pembayaran from './components/Pembayaran';
import Booking from './components/Booking';
import Footer from './components/Footer';
import Tnc from './components/Tnc';
import Faq from './components/Faq';

// Meta configuration for each route
const metaConfig = {
  home: {
    title: 'Vavelle & Co Rental Mobil Wedding, Antar Jemput Bandara, Harian',
    description: 'Welcome to Rentalin Indonesia, your go-to for all car rental services in Indonesia.',
    keywords: 'car rental, Indonesia, rental services, home'
  },
  tentangKami: {
    title: 'About Us',
    description: 'Learn more about Rentalin Indonesia, our history, mission, and vision.',
    keywords: 'about us, company history, mission, vision, Rentalin Indonesia'
  },
  tnc: {
    title: 'Syarat dan Kondisi',
    description: 'Syarat dan kondisi about our car rental services in Indonesia.',
    keywords: 'syarat dan kondisi, tnc, car rental, Indonesia'
  },
  faq: {
    title: 'FAQ Frequent Asked Questions',
    description: 'Frequently Asked Questions about our car rental services in Indonesia.',
    keywords: 'faq, car rental, Indonesia'
  },  
  lokasi: {
    title: 'Locations',
    description: 'Find our locations across Indonesia for easy car rental pick-up and drop-off.',
    keywords: 'locations, car rental locations, Indonesia, pick-up, drop-off'
  },
  kendaraan: {
    title: 'Vehicles',
    description: 'Explore our fleet of vehicles available for rent across Indonesia.',
    keywords: 'vehicles, car rental, fleet, Indonesia'
  },
  pembayaran: {
    title: 'Payment',
    description: 'Learn about our payment options for renting cars in Indonesia.',
    keywords: 'payment, payment methods, car rental, Indonesia'
  },
  booking: {
    title: 'Booking',
    description: 'Get in touch with us for any inquiries or support regarding car rentals in Indonesia.',
    keywords: 'contact us, support, inquiries, car rental, Indonesia'
  }
};

// Page wrapper component to handle meta tags
const PageWrapper = ({ meta, children }) => (
  <>
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
    </Helmet>
    {children}
  </>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Helmet defaultTitle="Rentalin Indonesia">
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
          </Helmet>

          <Header />
          <main className="flex-grow">
            <Routes>
              <Route 
                path="/" 
                element={
                  <PageWrapper meta={metaConfig.home}>
                    <MainContent />
                  </PageWrapper>
                }
              />
              <Route 
                path="/tentang-kami" 
                element={
                  <PageWrapper meta={metaConfig.tentangKami}>
                    <TentangKami />
                  </PageWrapper>
                }
              />
              <Route 
                path="/tnc" 
                element={
                  <PageWrapper meta={metaConfig.tnc}>
                    <Tnc />
                  </PageWrapper>
                }
              />
              <Route 
                path="/faq" 
                element={
                  <PageWrapper meta={metaConfig.faq}>
                    <Faq />
                  </PageWrapper>
                }
              />              
              <Route 
                path="/lokasi" 
                element={
                  <PageWrapper meta={metaConfig.lokasi}>
                    <Lokasi />
                  </PageWrapper>
                }
              />
              <Route 
                path="/kendaraan" 
                element={
                  <PageWrapper meta={metaConfig.kendaraan}>
                    <Kendaraan />
                  </PageWrapper>
                }
              />
              <Route 
                path="/pembayaran" 
                element={
                  <PageWrapper meta={metaConfig.pembayaran}>
                    <Pembayaran />
                  </PageWrapper>
                }
              />
              <Route 
                path="/booking" 
                element={
                  <PageWrapper meta={metaConfig.booking}>
                    <Booking />
                  </PageWrapper>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;